module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("S")]), _vm._v("he woke up thinking, “Thank G-D it's Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About to begin a three-day seminar on attaining wealth, she had no clue how euphoric, bone chilling, jubilating, and yet frightening this weekend would unfold. The wild ride she would take for the next seventy-two hours would be a series of events far more profound than any experience she could have imagined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The actual title for this seminar was ‘Passageways to Riches.’ She had attended a wealth seminar once before held by a different organization. That previous seminar had a cost of fifteen hundred dollars but she was able to bring a friend at no extra charge. She brought Fred and split the cost with him. It took her two months to save up the seven hundred and fifty dollars in order to attend. She thought they had presented a vast amount of information and covered many areas of business. She received handouts and workbooks but never took action to apply what she had learned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The invitation to this ‘Passageways to Riches’ seminar came to her via an email from an apparent affiliate sponsor called Enoch Enterprises. At seven, when her alarm went off she sat up on her bed and spoke to herself as she often does using her own mental dialogue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following is her detailed account of the weekend.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443afbb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 81
// module chunks = 0